module.exports = __webpack_public_path__ + "img/sample_app.abf1307e.png";